import script from "./TutorialCourseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TutorialCourseModal.vue?vue&type=script&setup=true&lang=ts"

import "./TutorialCourseModal.vue?vue&type=style&index=0&id=671cf433&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671cf433"]])

export default __exports__